import React,
{
  useState,
} from 'react';

import {
  useTranslation,
} from 'react-i18next';

import {
  useDispatch,
} from 'react-redux';

import {
  APP_SNACKBAR_ACTION,
} from '@noitada/redux-config/reducers/app.store';

import {
  Colors,
  Images,
} from '@noitada/shared/constants';

import Vars from '@noitada/shared/environments/variables';

import {
  TranslateConfig,
} from '@noitada/shared/translations';

import {
  Overlay,
} from '../../components/Composh/web';

import CopiedItem from '../../components/Contents/CopiedItem';
import HeaderModal from '../../components/Headers/HeaderModal';

import {
  IconCopy,
  IconEmail,
  IconSocialFacebook,
  IconSocialLinkedIn,
  IconSocialTwitter,
  IconSocialWhatsApp,
} from '../../components/Icons';

import {
  openEmail,
  openAppWeb,
} from '../../config/linking.config';

import NameRoutes from '../../navigation/names';

import {
  ShareEventContainer,
  ShareEventBannerView,
  ShareEventBannerImage,
  ShareEventContent,
  ShareEventItemButton,
  ShareEventItemIcon,
  ShareEventItemText,
} from './styled';



export interface IProps {
  type: 'EVENT' | 'COMPANY';
  visible?: boolean;
  idEvent: string;
  name?: string;
  image?: string;
  onClose?: any;
  onPress?: any;
}



const ShareModal: React.FC<IProps> = (props: IProps) => {
  const visibleModal = props.visible;
  if (!visibleModal) {
    return null;
  }


  const dispatch = useDispatch();
  const { t: translate } = useTranslation();


  const sizeIcon = 18;
  const idEventShort = props.idEvent;

  const imageBanner = props.image || Images.placeholderEvent;


  const [copied, setCopied] = useState<boolean>(false);



  function showSnackBarProps(snackColor: string, snackText: string) {
    dispatch({
      type: APP_SNACKBAR_ACTION,
      payload: {
        visible: true,
        color: snackColor,
        text: snackText,
      },
    });
  }


  function renderShareButton(icon: any, title: string, onPress: any) {
    return (

      <ShareEventItemButton
        onClick={() => {
          if (onPress) {
            onPress();
          }
        }}>

        {icon}


        <ShareEventItemText>
          {title}
        </ShareEventItemText>

      </ShareEventItemButton>

    );
  }


  function controlLinkText(): { title: string, link: string } | null {
    if (props.type === 'EVENT') {
      return {
        title: 'Veja esse evento na Noitada',
        link: `${Vars()?.noitadaAppLink}${NameRoutes.DetailsEventScreen.replace(
          ':event_id',
          idEventShort,
        )}`,
      };
    }

    if (props.type === 'COMPANY') {
      return {
        title: 'Veja esse parceiro na Noitada',
        link: `${Vars()?.noitadaAppLink}${NameRoutes.DetailsCompanyScreen.replace(
          ':company_username',
          idEventShort,
        )}`,
      };
    }

    return null;
  }


  function onCopyLinkPress() {
    setCopied(true);
    navigator.clipboard.writeText(controlLinkText()?.link || '');
    showSnackBarProps(Colors.accept, translate(TranslateConfig.SUCCESS_COPIED_LINK));

    setTimeout(() => {
      setCopied(false);
    }, 1000);
  }


  function onWhatsAppPress() {
    const textEncoded = `${controlLinkText()?.title}: ${controlLinkText()?.link}`;
    const shareURL = `https://wa.me/?text=${textEncoded}`;
    openAppWeb(shareURL);

    if (props.onClose) {
      props.onClose();
    }
  }


  function onTwittterPress() {
    const textEncoded = encodeURIComponent(`${controlLinkText()?.title}: ${controlLinkText()?.link}`);

    const messageURL = `https://twitter.com/intent/tweet?text=${textEncoded}`;
    openAppWeb(messageURL);

    if (props.onClose) {
      props.onClose();
    }
  }


  function onFacebookPress() {
    const textEncoded = encodeURIComponent(`${controlLinkText()?.title}: ${controlLinkText()?.link}`);

    const messageURL = `https://www.facebook.com/sharer/sharer.php?u=${textEncoded}`;
    openAppWeb(messageURL);

    if (props.onClose) {
      props.onClose();
    }
  }


  function onLinkedInPress() {
    const textEncoded = encodeURIComponent(`${controlLinkText()?.title}: ${controlLinkText()?.link}`);

    const messageURL = `https://www.linkedin.com/shareArticle?url=${textEncoded}`;
    openAppWeb(messageURL);

    if (props.onClose) {
      props.onClose();
    }
  }


  function onEmailPress() {
    const messageURL = controlLinkText()?.link || '';
    openEmail(controlLinkText()?.title || '', messageURL);

    if (props.onClose) {
      props.onClose();
    }
  }



  return (

    <Overlay
      visible={props.visible}
      showBackground={true}
      overlayColor={Colors.menuOverlay}
      onOverlayPress={props.onClose}>

      <ShareEventContainer>

        <HeaderModal
          title={translate(TranslateConfig.SHARE)}
          subtitle={props.name}
          onPress={props.onClose}
        />


        <ShareEventBannerView>

          <ShareEventBannerImage
            src={imageBanner}
          />

        </ShareEventBannerView>


        <ShareEventContent>

          {renderShareButton(
            <CopiedItem
              copied={copied}
              icon={
                <IconCopy
                  color={Colors.white}
                  size={sizeIcon}
                />
              }
            />,
            translate(TranslateConfig.ACTION_COPY_LINK),
            () => {
              onCopyLinkPress();
            },
          )}


          {renderShareButton(
            <ShareEventItemIcon>
              <IconSocialWhatsApp
                color={Colors.white}
                size={sizeIcon}
              />
            </ShareEventItemIcon>,
            translate(TranslateConfig.WHATSAPP),
            () => {
              onWhatsAppPress();
            },
          )}


          {renderShareButton(
            <ShareEventItemIcon>
              <IconSocialTwitter
                color={Colors.white}
                size={sizeIcon}
              />
            </ShareEventItemIcon>,
            translate(TranslateConfig.TWITTER),
            () => {
              onTwittterPress();
            },
          )}


          {renderShareButton(
            <ShareEventItemIcon>
              <IconSocialFacebook
                color={Colors.white}
                size={sizeIcon}
              />
            </ShareEventItemIcon>,
            translate(TranslateConfig.FACEBOOK),
            () => {
              onFacebookPress();
            },
          )}


          {renderShareButton(
            <ShareEventItemIcon>
              <IconSocialLinkedIn
                color={Colors.white}
                size={sizeIcon}
              />
            </ShareEventItemIcon>,
            translate(TranslateConfig.LINKEDIN),
            () => {
              onLinkedInPress();
            },
          )}


          {renderShareButton(
            <ShareEventItemIcon>
              <IconEmail
                color={Colors.white}
                size={sizeIcon}
              />
            </ShareEventItemIcon>,
            translate(TranslateConfig.EMAIL),
            () => {
              onEmailPress();
            },
          )}

        </ShareEventContent>

      </ShareEventContainer>

    </Overlay>

  );
};



export default ShareModal;
